import type { ReactNode } from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";
import { CommandCopyBox } from "@/components/common/command-copy-box";

export interface WhatsNextCardProps {
  title: string;
  description: string;
  command?: string | null;
  commandLabel?: string | null;
  commandHelperText?: string | null;
  /** Optional action slot rendered below the command (e.g. an End Session button). */
  action?: ReactNode;
  className?: string;
}

export function WhatsNextCard({
  title,
  description,
  command,
  commandLabel,
  commandHelperText,
  action,
  className,
}: WhatsNextCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className={cn(className)}
    >
      <div className="rounded-xl border border-white/[0.08] bg-white/[0.02] overflow-hidden">
        <div className="border-l-2 border-purple-500/60 p-4 space-y-3">
          <div>
            <p className="text-sm font-medium text-foreground">{title}</p>
            <p className="text-sm text-muted-foreground mt-1">
              {description}
            </p>
          </div>

          {command && (
            <CommandCopyBox
              label={commandLabel ?? "Run this command"}
              command={command}
              helperText={commandHelperText ?? "Paste into Copilot chat"}
            />
          )}

          {action}
        </div>
      </div>
    </motion.div>
  );
}
